

<template>
  <div class="sidebar-container" :class="{'is-active':isCollapse}">
      <logo :isCollapse="isCollapse"></logo>
      <div class="out-menu">
        <div class="inner-menu2">
          <el-menu unique-opened = "true"
                   :default-active="nowTagValue"
                   mode="vertical"
                   class="el-menu-vertical-demo2 el-menu-common"
                   :collapse="isCollapse"
                   :default-openeds="opened"
          >
            <sidebar-item :menuData="menu" :isCollapse="isCollapse"></sidebar-item>
          </el-menu>
        </div>
      </div>
			<div class="home_shousuo">
				<svg class="icon"  aria-hidden="true" @click="showCollapse">
								<use :xlink:href="isCollapse?'#icon-home_shousuo_h_icon':'#icon-home_shousuo_icon'"></use>
				</svg>
			</div>
  </div>
</template>

<script>
import { setUrlPath } from '@/util/util';
import { mapGetters } from 'vuex';
import SidebarItem from './sidebarItem';
import logo from './logo';
  import store from '@/store';
import platformMenus from '@/menus/demo/demo';
// import homeMenus from '@/menus/home/home';
import homeMenus2 from '@/menus/home/home2';
import wageMenus from '@/menus/wage/wage';
import hrCloudMenus from '@/menus/hrcloud/hrMenu.js';
import hrCloudSetMenus from '@/menus/hrcloud/hrSetMenu.js';
import reportMenus from '@/menus/wage/report.js';
import tesla from '@/menus/wage/tesla.js';
import { deepCopy, getAuthorizedMenu } from '@/util/util';
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'

export default {
  name: 'sidebar',
  components: { SidebarItem ,logo},
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽度
      localMenu: [],
    };
  },
  created() {
    this.isLocal = process.env.VUE_APP_LOCAL_DEVELOPMENT
    if(this.screenWidth <= 1400) {
      this.$store.commit('SET_COLLAPSE');
    }
    let newMenusArray = homeMenus2.concat(hrCloudMenus);
    newMenusArray =newMenusArray.concat(wageMenus);
    newMenusArray =newMenusArray.concat(reportMenus);
    newMenusArray =newMenusArray.concat(hrCloudSetMenus);
    newMenusArray =newMenusArray.concat(tesla);
    // newMenusArray =newMenusArray.concat(platformMenus);
    this.localMenu = newMenusArray;
    let menuData = deepCopy(newMenusArray);
    const menuSet = this.pms[1].map(item=>{
      return item.operateCode;
    })
    this.$store.commit('SET_MENU', getAuthorizedMenu(menuData, menuSet));
    // this.$store.commit('SET_MENU',menuData);
    //this.initWebSocket();
  },
  computed: {
    ...mapGetters(['isCollapse','pms', 'menu','opened','memberInfo', 'accessToken','cusLogo']),
    nowTagValue() {
      return setUrlPath(this.$route);
    },
  },
  mounted() {
  },
  methods: {
		showCollapse(){
			this.$store.commit("SET_COLLAPSE");
		},
    initWebSocket() {
      this.connection();
      let that= this;
      // 断开重连机制,尝试发送消息,捕获异常发生时重连
      // this.timer = setInterval(() => {
      //   try {
      //     that.stompClient.send("test");
      //   } catch (err) {
      //     console.log("断线了: " + err);
      //     that.connection();
      //   }
      // }, 5000);
    },
    //上线
    connection(){
      //console.log("111用户信息：",this.userInfo);
      console.log("111用户信息member：",this.memberInfo);
      console.log("111用户信息user：",this.user);
      console.log("111用户信息tenantInfo：",this.tenantInfo);
      console.log("111用户信息clientInfo：",this.clientInfo);
      console.log("111用户信息pms：",this.pms);
      //建立连接对象
        let baseUrl = process.env.VUE_APP_BASE_URL;
        //建立连接对象
        let socket = new SockJS("/api/message/ws");
     // debugger
      // 获取STOMP子协议的客户端对象
      this.stompClient = Stomp.over(socket);
      //将socket对象存在session里
      // sessionStorage.setItem("stompClient", this.stompClient);
      this.stompClient.debug = null
      // 定义客户端的认证信息,按需求配置
      let headers = {
        'Authorization': 'Bearer ' + this.accessToken
      };
      // 向服务器发起websocket连接
      this.stompClient.connect(headers,() => {
        console.log("连接websocket成功")
        this.stompClient.subscribe('/user/'+ this.memberInfo.id +'/message', (msg) => {
          // msg.body存放的是服务端发送给我们的信息
          console.log('广播成功', msg.body)
          console.log(this.$route.path)
          if(this.$route.path != '/index'){
            this.$notify.info({
              title: '消息',
              message: '您有新的消息，请注意查收'
            });
          }
          this.resetSetItem('sockedMsgContent', msg.body);
        },headers);
      }, (err) => {
        // 连接发生错误时的处理函数
        console.log('失败')
        console.log(err);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.out-menu{
	width: 245px;
	height: calc(100vh - 150px);
	overflow-x: hidden;
	overflow-y:auto ;
}
.el-menu-vertical-demo2:not(.el-menu--collapse) {
  width: 100%;
}

/* for Chrome */
.inner-menu2::-webkit-scrollbar {
    display: none;
}

 #app .el-menu{
	 background: #4278D2 !important;
 }
.home_shousuo{
	padding-left: 20px;
	color: #fff;
	font-size: 18px;
	cursor: pointer;
}
/*.sidebar-container.is-active{*/
/*  width: 80px !important;*/
/*}*/
</style>
<style>
  /*.el-menu--popup-right-start{*/
  /*  margin-left: 1px !important;*/
  /*}*/
  .inner-menu2 .el-menu {
    background: #4278D2 !important;
  }

  .inner-menu2 .el-menu-vertical-demo2 {
    background: #4278D2 !important;
  }
  .inner-menu2 .el-menu-vertical-demo2 .el-menu-item {
    background: #4278D2 !important;
  }

  /** 打开点击之后的状态 */
  .inner-menu2 .el-menu-vertical-demo2 .el-menu-item {
    border-bottom-right-radius: 30px;
    border-top-right-radius: 30px;
  }

  /** 鼠标滑动之后 */
  .inner-menu2 .el-menu-vertical-demo2 .el-menu-item:hover {
    background: rgba(0, 0, 0, 0.1) !important;
  }

  /** 打开点击之后的状态 */
  .inner-menu2 .el-menu-vertical-demo2 .el-menu-item.is-active {
    color: #607BDF !important;
    font-weight: bold;
    background: #fff !important;
  }
  .inner-menu2 .el-menu-vertical-demo2 .el-menu-item.is-active .icon {
    color: #607BDF !important;
  }

  /** 有子菜单时 一级菜单背景色 */
  .inner-menu2 .el-menu-vertical-demo2 .el-submenu.is-active > div {
    background: rgba(0, 0, 0, 0.1) !important;
    border-bottom-right-radius: 30px;
    border-top-right-radius: 30px;
  }


  /** 鼠标滑动有二级菜单时 的 一级菜单 */
  .inner-menu2 .el-menu-vertical-demo2 .el-submenu__title {
    border-bottom-right-radius: 30px;
    border-top-right-radius: 30px;
  }
  .inner-menu2 .el-menu-vertical-demo2 .el-submenu__title:hover {
    background: rgba(0, 0, 0, 0.1) !important;
  }

  /* .el-menu-vertical-demo2 .el-menu .el-menu-item:hover {
    background: #4278D2 !important;
  } */

  /** 浮框 */
  .light-theme2 .el-menu--popup .el-menu-item:hover {
    background: rgba(0, 0, 0, 0.1);
  }
  .light-theme2 .el-menu--popup .el-menu-item {
    background-color: #4278D2 !important;
  }

  .light-theme2 .el-menu--vertical  .el-menu-item.is-active:before{
     background-color: #607BDF;
  }

</style>
